import React from "react";
import Navbar from "@/components/Navbar";
import Footer from "@/components/Footer";

const SiteLayout = ({ children }) => (
  <div id="top" className="min-h-screen flex flex-col bg-[#0A0A0A] text-white">
    <Navbar />
    <main className="flex-1">{children}</main>
    <Footer />
  </div>
);

export default SiteLayout;
